



















import commons from "@/common/store/modules/commons";
import { Prop, Watch, Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

@Component
export default class TheC01ItemThumbnailsPc extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return [];
    }
  })
  thumbnails!: any;

  main = "";

  get haveThumnails() {
    return this.thumbnails.length > 0;
  }

  get colorCode() {
    return commons.OrgPageSpecific?.page_color;
  }

  @Watch("thumbnails")
  onThumbnail() {
    this.initMain();
  }

  selectSub(sub: any) {
    this.main = sub;
  }
  selectedStyle(sub: any) {
    return this.main === sub ? `border: 1px solid ${this.colorCode}` : "";
  }
  initMain() {
    this.main = this.haveThumnails ? this.thumbnails[0] : {};
  }

  created() {
    this.initMain();
  }
}
